<template>
  <load-content :loading="standardBreakdowns.isBusy">
    <div class="container" v-if="!false">
      <div class="card clearfix">
        <div class="filter-categories">
          <InputSelect
            :value="currentTab"
            :options="standardBreakdowns.data"
            :show-labels="false"
            :searchable="true"
            :allow-empty="false"
            option-value="id"
            option-label="name"
            @change="changeBreakdown"
          />
        </div>
        <div class="content">
          <div class="container-tags">
              <datatable
                :data="datatable"
                :updatingRow="updatingRowId"
                :loading="standardBreakdownDetails.isBusy"
                class="striped"
              />
          </div>
        </div>
      </div>
    </div>
  </load-content>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DataTable from '../datatable';
import { FIELD_TYPE } from '../../config/const';
import InputSelect from '../form-components/input-select';
import LoadContent from '../load-content';

export default {
  components: {
    datatable: DataTable,
    InputSelect,
    LoadContent,
  },
  computed: {
    ...mapState({
      standardBreakdowns: state => state.admin.breakdowns.breakdowns,
      standardBreakdownDetails: state => state.admin.breakdowns.breakdownDetails
    }),

    projectId() {
      return this.$route.params.project_uid;
    },
   
    currentBreakdown() {
      return this.standardBreakdowns.data.find(breakdown => breakdown.id === this.currentTab);
    },

    datatable() {

      const body = (this.standardBreakdownDetails.data || []).map(dt => {
        const name = this.currentBreakdown.value === "outlet-media-type" ? this.$i18n.t('outlets.media_types.' + dt.name) : dt.name;
        return { ...dt, name }
      });

      return {
        columns: [
          {
            key: 'name',
            label: 'Name',
            render: (row) => {
              return <span class="text-truncate">{row.name}</span>;
            }
          },
          {
            key: 'color',
            label: 'Color',
            input: {
              name: 'color',
              type: FIELD_TYPE.COLOR,
              onChange: (value, key, row) => {
                const color = value.hex || value;
                this.updateRow(color, key, row);
              }
            },
            cellStyle: {
              width: '100%'
            }
          }
        ],
        body
      }
    }
  },
  watch: {
    'standardBreakdowns.data': {
      handler(value) {
        if (value && value.length > 0) {
          this.currentTab = value[0].id;
        }
      }
    },

    currentTab: {
      handler(value) {
        this.getBreakdownDetails({ projectId: this.projectId, breakdownId: value });
      }
    }
  },
  mounted: async function() {
    this.getBreakdowns({ projectId: this.projectId });
  },
  methods: {
    ...mapActions({
      getBreakdowns: 'admin/breakdowns/getBreakdowns',
      getBreakdownDetails: 'admin/breakdowns/getBreakdownDetails',
      updateStandardBreakdownSettings: 'admin/breakdowns/updateStandardBreakdownSettings'
    }),

    getBreakdownChildren(breakdownId) {
      return this.getFullStandardBreakdown({
        projectId: this.projectId,
        queryId: this.queryId,
        breakdownId
      });
    },

    changeBreakdown(value) {
      this.currentTab = value;
    },

    updateRow(color, key, row) {
      this.updatingRowId = row.id;
      this.updateStandardBreakdownSettings({ projectId: this.projectId, breakdownId: row.parent_id, settings: {color: color}, breakdownOptionName: this.currentTab === 2 ? row.value : row.id }).then(r => {
        this.updatingRowId = null;
      });
    }
  },

  data: function() {
    return {
      updatingRowId: null,
      currentTab: null
    };
  },
};
</script>

<style lang="scss" scoped>
  .filter-categories {
    max-width: 240px;
  }
</style>
